import { BaseResAPI } from "@/@core/entity/res-api.entity";
import api from "@/api/axios";

export interface CreateProductDTO {
  name: string;
  category: string;
  master_sku: string;
  season: string;
  size: string;
  colour: string;
  price: number;
  description: string;
  status: number;
  media_ids: string[];
}

export type CreateProductResp = BaseResAPI<null>;

const createProductInteractor = (
  body: CreateProductDTO
): Promise<CreateProductResp> => {
  const path = `/admin/product`;

  return api.post(path, body);
};

export default createProductInteractor;
